import * as React from "react";
import { Card } from "@mantine/core";

const headingPadding = "20px";

const PrivacyPolicyPage: React.FunctionComponent = () => (
  <Card
    style={{
      maxWidth: "800px",
      width: "80%",
      margin: "50px auto",
      padding: "5%",
    }}
  >
    <h2 className="logo" style={{ margin: "auto", marginBottom: "50px" }}>
      StadiumSupervisor Privacy Policy
    </h2>
    <p>
      Your privacy is important to us. It is Stadium Supervisor's policy to
      respect your privacy regarding any information we may collect from you
      across our website,{" "}
      <a href="https://stadiumsupervisor.com.au">
        https://stadiumsupervisor.com.au
      </a>
      , and other sites we own and operate (hereinafter, "us", "we", or
      "https://stadiumsupervisor.com.au").
    </p>
    <p>
      We respect your privacy and are committed to protecting personally
      identifiable information you may provide us through the Website. We have
      adopted this privacy policy ("Privacy Policy") to explain what information
      may be collected on our Website, how we use this information, and under
      what circumstances we may disclose the information to third parties. This
      Privacy Policy applies only to information we collect through the Website
      and does not apply to our collection of information from other sources.
    </p>
    <p>
      We only ask for personal information when we truly need it to provide a
      service to you. We collect it by fair and lawful means, with your
      knowledge and consent. We also let you know why we’re collecting it and
      how it will be used. We only retain collected information for as long as
      necessary to provide you with your requested service. What data we store,
      we’ll protect within commercially acceptable means to prevent loss and
      theft, as well as unauthorised access, disclosure, copying, use or
      modification.
    </p>
    <p>
      Our website may link to external sites that are not operated by us. Please
      be aware that we have no control over the content and practices of these
      sites, and cannot accept responsibility or liability for their respective
      privacy policies.
    </p>
    <h4 style={{ marginTop: headingPadding }}>Collecting information</h4>
    <p>
      Like most website operators, StadiumSupervisor collects
      non-personally-identifying information of the sort that web browsers and
      servers typically make available, such as the browser type, language
      preference, referring site, and the date and time of each visitor request.
      StadiumSupervisor's purpose in collecting non-personally identifying
      information is to better understand how StadiumSupervisor's visitors use
      its website. From time to time, StadiumSupervisor may release
      non-personally-identifying information in the aggregate, e.g., by
      publishing a report on trends in the usage of its website.
    </p>
    <p>
      StadiumSupervisor also collects potentially personally-identifying
      information like Internet Protocol (IP) addresses for logged in users and
      for users interacting on https://stadiumsupervisor.com.au.
      StadiumSupervisor only discloses logged in user's IP addresses under the
      same circumstances that it uses and discloses personally-identifying
      information as described below.
    </p>
    <h4 style={{ marginTop: headingPadding }}>Cookies</h4>
    <p>
      To enrich and perfect your online experience, StadiumSupervisor uses
      "Cookies", similar technologies and services provided by others to display
      personalized content and store your preferences on your computer.
      StadiumSupervisor uses cookies to help StadiumSupervisor identify and
      track visitors, their usage of https://stadiumsupervisor.com.au, and their
      website access preferences.
    </p>
    <p>
      StadiumSupervisor visitors who do not wish to have cookies placed on their
      computers should set their browsers to refuse cookies before using
      StadiumSupervisor's websites, with the drawback that certain features may
      not function properly without the aid of cookies. By continuing to
      navigate our website without changing your cookie settings, you hereby
      acknowledge and agree to StadiumSupervisor's use of cookies.
    </p>
    <h4 style={{ marginTop: headingPadding }}>Security</h4>
    <p>
      The security of your Personal Information is important to us, but remember
      that no method of transmission over the Internet, or method of electronic
      storage is 100% secure. While we strive to use commercially acceptable
      means to protect your Personal Information, we cannot guarantee its
      absolute security.
    </p>
    <h4 style={{ marginTop: headingPadding }}>
      Updates to this Privacy Policy
    </h4>
    Although most changes are likely to be minor, StadiumSupervisor may change
    its Privacy Policy from time to time, and in StadiumSupervisor's sole
    discretion. StadiumSupervisor encourages visitors to frequently check this
    page for any changes to its Privacy Policy. Your continued use of this site
    after any change in this Privacy Policy will constitute your acceptance of
    such change.
    <hr />
    <p style={{ color: "darkgray", fontSize: "12px" }}>
      This privacy policy was created at
      https://termsandconditionstemplate.com/privacy-policy-generator/. If you
      have any questions about this Privacy Policy, please contact us via email.
    </p>
  </Card>
);

export default PrivacyPolicyPage;
